<nz-affix [nzOffsetTop]="0">
  <hx-breadcrumbs></hx-breadcrumbs>
  <nz-page-header nzBackIcon [nzGhost]="false">
    <nz-page-header-title>{{(isEdit ? 'action.edit' : 'action.create') | transloco}}</nz-page-header-title>
  </nz-page-header>
</nz-affix>
<nz-skeleton [nzActive]="true" [nzLoading]="isLoading.model">
  <form nz-form class="hx-form" [nzLayout]="'vertical'" [formGroup]="form" (ngSubmit)="submitForm()" *transloco="let tr; prefix: 'productDefinitions'; scope: 'product-definitions'">
    <div nz-row [nzGutter]="8">
      <div nz-col class="hx-col-2">
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('form.outProductInfo')}}</nz-form-label>
          <nz-form-control>
            <hx-product-info-select [types]="types" formControlName="outProductInfoId"></hx-product-info-select>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <div nz-row [nzGutter]="8">
      <div nz-col class="hx-col-2">
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('form.shape')}}</nz-form-label>
          <nz-form-control>
            <hx-enum-select enumName="Shape" [enumType]="Shape" formControlName="shape"></hx-enum-select>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <div nz-row [nzGutter]="8">
      <div nz-col>
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('form.splitQuantity')}}</nz-form-label>
          <nz-form-control>
            <nz-select formControlName="splitQuantity" nzShowSearch nzAllowClear nzPlaceHolder="Выберите кол-во деление" [nzDropdownMatchSelectWidth]="false">
              <nz-option *ngFor="let q of splitQuantityOptions" [nzValue]="q" [nzLabel]="q"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>

      <div nz-col>
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('form.productSize')}}</nz-form-label>
          <nz-form-control>
            <nz-select formControlName="inProductSize" nzShowSearch nzAllowClear nzPlaceHolder="Выберите размер продукта" [nzDropdownMatchSelectWidth]="false">
              <nz-option *ngFor="let q of productSizeOptions" [nzValue]="q" [nzLabel]="q"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <nz-alert *ngIf="form.invalid" nzType="error" [nzMessage]="'error.fillRequiredFields' | transloco" nzShowIcon></nz-alert>

    <div nz-row [nzGutter]="8" class="cp_actions">
      <div nz-col>
        <nz-form-item>
          <nz-form-control>
            <button [nzLoading]="isSaving" [disabled]="form.pristine || form.pending" type="submit" nz-button nzType="primary">
              <i nz-icon nzType="save" nzTheme="outline"></i> {{'button.save' | transloco}}
            </button>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col>
        <nz-tag nzColor="success" *ngIf="form.pristine && model.id">
          <i nz-icon nzType="check-circle"></i>
          <span>{{'form.saved' | transloco}}</span>
        </nz-tag>
      </div>
    </div>
  </form>
</nz-skeleton>
